import { useQuery } from '@tanstack/react-query';

import { BanksApi } from 'api';
import { DISPENSARY_BANNER_STATUS_KEY } from '../../keys';
import { useUser } from '../useUser';

export function useDispensaryBannerStatus(dispensaryId: string) {
  const banksApi = new BanksApi();
  const { userBankId } = useUser();

  const { data: dispensaryBannerStatus, isLoading: isLoadingDispensaryBannerStatus } = useQuery({
    enabled: !!userBankId.length,
    queryKey: [DISPENSARY_BANNER_STATUS_KEY, userBankId, dispensaryId],
    queryFn: () => banksApi.getDispensaryBannerStatus(userBankId, dispensaryId),
    staleTime: 30 * 60 * 1000 // 5 minutes
  });
  return { dispensaryBannerStatus, isLoadingDispensaryBannerStatus };
}
